import CoinStats from './CoinStats';

export default CoinStats;
